import { ChangeDetectionStrategy, Component, Inject } from '@angular/core'
import { CookieStorageService } from '@features/cookie-consents/cookie-storage.service'
import { WINDOW } from '@features/storage/window'
import { map } from 'rxjs'
import { ClickTriggerForDirective } from '../../click-trigger-for/click-trigger-for.directive'
import { MatButton } from '@angular/material/button'
import { RouterLink } from '@angular/router'
import { AsyncPipe } from '@angular/common'

@Component({
    selector: 'app-cookie-overlay',
    templateUrl: './cookie-overlay.component.html',
    styleUrls: ['./cookie-overlay.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLink, MatButton, ClickTriggerForDirective, AsyncPipe]
})
export class CookieOverlayComponent{

  readonly openPreferencesCenter: () => void

  readonly show$ = this.cookie.userAccepted$.pipe(map(v => !v))

  constructor(private cookie: CookieStorageService, @Inject(WINDOW) readonly window: Window) {
    this.openPreferencesCenter = window.cookieconsent?.openPreferencesCenter ?? (() => {})
  }

}
